import React from 'react';
import {NavLink} from 'react-router-dom';

import {List, ListItem} from '@mui/material';
import Box from "@mui/material/Box";
import {styled} from "@mui/material";


// React router add the class "active" to the NavLink when the "to"
// prop match the current location
const StyledListItem = styled(ListItem)(({ theme }) => ({
    "& .nav-link-box": {
        display: "flex",
        padding: "4px",
    },
    "&.active .nav-link-box": {
        color: theme.palette.primary.main,
        fontWeight: theme.typography.fontWeightMedium,
    },
    "& .nav-link-text": {
        marginLeft: "24px",
    },
}));

const Nav = props => {
    const {pages, className, onPageSelect} = props;

    return (
        <List className={className}>
            {pages.map(page => (
                <StyledListItem key={page.title}
                          component={NavLink}
                          to={page.href}
                          button
                          disableGutters
                          onClick={onPageSelect}>
                    <Box className="nav-link-box">
                        {page.icon}
                        <Box component="span" className="nav-link-text">
                            {page.title}
                        </Box>
                    </Box>
                </StyledListItem>
            ))}
        </List>
    );
};

export {Nav}